import { render, staticRenderFns } from "./editTabPendidikan.vue?vue&type=template&id=dc9ad802"
import script from "./editTabPendidikan.vue?vue&type=script&lang=js"
export * from "./editTabPendidikan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports